import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./faq.scss";

const faqData = [
  {
    question: "Как работает детокс на соках?",
    answer:
      "Детокс на соках помогает организму естественным образом очиститься от токсинов. Вы получаете все необходимые питательные вещества из свежевыжатых соков, при этом пищеварительная система отдыхает и восстанавливается.",
  },
  {
    question: "Можно ли заниматься спортом во время курса?",
    answer:
      "Рекомендуем ограничиться лёгкими нагрузками: йога, прогулки, лёгкая растяжка. Интенсивные тренировки лучше отложить до окончания курса.",
  },
  {
    question: "Как хранить соки?",
    answer:
      "Соки нужно хранить в холодильнике при температуре 2-6°C. Употребить в течение 24 часов после получения. Перед употреблением хорошо взболтать.",
  },
  {
    question: "Есть ли противопоказания?",
    answer:
      "Курс не рекомендуется беременным и кормящим женщинам, людям с серьёзными заболеваниями. Обязательно проконсультируйтесь с врачом перед началом программы.",
  },
  {
    question: "Что делать, если стало плохо?",
    answer:
      "Лёгкое недомогание в первые дни - нормальная реакция организма. При серьёзном дискомфорте свяжитесь с нами или прекратите курс и обратитесь к врачу.",
  },
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq">
      <h2 className="faq-title">Часто задаваемые вопросы</h2>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <button className="faq-question" onClick={() => toggle(index)}>
              <span>{item.question}</span>
              <FaChevronDown
                className={`faq-icon ${activeIndex === index ? "rotate" : ""}`}
              />
            </button>
            <div
              className="faq-answer"
              style={{
                maxHeight: activeIndex === index ? "300px" : "0px",
              }}
            >
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
